import {Page} from '../lib/material-ui-components'

declare let React: any
declare let ReactRouterDOM: any

const {withRouter} = ReactRouterDOM

const Blocked = withRouter(({location, history}) => {
  return (
    <Page title='Accesso Negato - Museo Genio' top={true}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '70vh',
        textAlign: 'center',
        padding: '40px',
        background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
        borderRadius: '20px',
        margin: '20px',
        color: 'white'
      }}>
        <div style={{
          fontSize: '6em',
          marginBottom: '20px'
        }}>
          🚫
        </div>

        <h1 style={{
          fontSize: '2.5em',
          marginBottom: '20px',
          fontWeight: 'bold'
        }}>
          Accesso Negato
        </h1>
        
        <h2 style={{
          fontSize: '1.3em',
          marginBottom: '30px',
          opacity: '0.9',
          maxWidth: '600px'
        }}>
          Non sei autorizzato ad accedere a questa sezione del Museo Genio
        </h2>

        <div style={{
          background: 'rgba(255,255,255,0.1)',
          padding: '30px',
          borderRadius: '15px',
          marginBottom: '30px',
          maxWidth: '500px',
          width: '100%'
        }}>
          <h3 style={{
            fontSize: '1.2em',
            marginBottom: '20px',
            color: '#fff'
          }}>
            ℹ️ Informazioni
          </h3>
          
          <div style={{ 
            textAlign: 'left', 
            lineHeight: '1.8',
            fontSize: '1em'
          }}>
            <p>• <strong>Motivo:</strong> Token di accesso non valido o scaduto</p>
            <p>• <strong>Durata token:</strong> 2 ore dall'ultimo accesso</p>
            <p>• <strong>Sicurezza:</strong> Accesso limitato per proteggere il contenuto</p>
          </div>
        </div>

        <div style={{
          background: 'rgba(255,255,255,0.1)',
          padding: '25px',
          borderRadius: '15px',
          maxWidth: '500px',
          width: '100%',
          marginBottom: '30px'
        }}>
          <h3 style={{
            fontSize: '1.2em',
            marginBottom: '15px',
            color: '#fff'
          }}>
            🔐 Come Ottenere l'Accesso
          </h3>
          
          <p style={{ 
            lineHeight: '1.6',
            marginBottom: '15px'
          }}>
            Per accedere alle esperienze del Museo Genio, è necessario un <strong>codice di accesso autorizzato</strong> fornito dal personale del museo.
          </p>
          
          <p style={{ 
            lineHeight: '1.6',
            fontSize: '0.95em',
            opacity: '0.9'
          }}>
            Contatta il personale del museo per ottenere un nuovo codice di accesso valido.
          </p>
        </div>

        {/* Footer informativo */}
        <div style={{
          marginTop: '20px',
          padding: '20px',
          borderTop: '1px solid rgba(255,255,255,0.2)',
          fontSize: '0.9em',
          opacity: '0.8',
          maxWidth: '400px'
        }}>
          <p>🏛️ Museo Genio</p>
          <p>Sistema di Sicurezza Attivo</p>
        </div>
      </div>
    </Page>
  )
})

export {Blocked}
